import { initWidgets } from "tsi-common-react/src/widgets";

initWidgets();
